(function(){
	'use strict';
	
	angular
    .module('quantixApp')
    .controller('companyDetailsBarChartController', companyDetailsBarChartController);
	
	companyDetailsBarChartController.$inject=['$scope','$timeout'];
	
	function companyDetailsBarChartController($scope,$timeout){
		var gaugeChart=null
		
		$scope.initialise=function (){
			
			var config={
				    "type": "serial",
				    "theme": "none",
				    "legend": {
				        "equalWidths": false,
				        "useGraphSettings": true,
				        "valueAlign": "left",
				        "valueWidth": 120
				    },
				    "dataProvider": $scope.plotData['graph'],
				    "valueAxes": [{
				        "id": "volumeAxis",
				        "axisAlpha": 0,
				        "gridAlpha": 0,
				        "position": "right"
				        
				    }, {
				        "id": "indexAxis",
				        "axisAlpha": 0,
				        "gridAlpha": 0,
				        "position": "left"
				        
				       
				    }],
				    "graphs": [{
				        "alphaField": "alpha",
				        "balloonText": "[[value]]",
				        "dashLengthField": "dashLength",
				        "fillAlphas": 0.7,
				        "legendValueText": "[[value]]",
				        "title": "Volume Traded",
				        "type": "column",
				        "valueField": "noOfTrade",
				        "valueAxis": "volumeAxis"
				    },{
				        "balloonText": "[[value]]",
				        "bullet": "round",
				        "bulletBorderAlpha": 1,
				        "useLineColorForBulletBorder": true,
				        "bulletColor": "#647685",
				        "dashLengthField": "dashLength",
				        "labelPosition": "right",
				        "legendValueText": "[[value]]",
				        "title": "Market Price",
				        "fillAlphas": 0,
				        "valueField": "adjustedClosingPrice",
				        "valueAxis": "indexAxis"
				    }, {
				        "bullet": "square",
				        "bulletBorderAlpha": 1,
				        "bulletBorderThickness": 1,
				        "lineColor": "gray",
				        "color": "gray",
				        "dashLengthField": "dashLength",
				        "legendValueText": "[[value]]",
				        "title": $scope.plotData['indicesName'],
				        "fillAlphas": 0,
				        "valueField": "indexClosing",
				        "valueAxis": "indexAxis"
				    }],
				    "chartCursor": {
				        "categoryBalloonDateFormat": "DD-MMM-YYYY",
				        "cursorAlpha": 0.1,
				        "cursorColor":"#000000",
				         "fullWidth":true,
				        "valueBalloonsEnabled": false,
				        "zoomable": true
				    },
					    "dataDateFormat": "YYYY-MM-DD",
				    "categoryField": "scriptDate",
				    "categoryAxis": {
				    	"dateFormats": [{
				            "period": "DD",
				            "format": "MMM DD"
				        }, {
				            "period": "WW",
				            "format": "MMM DD"
				        }, {
				            "period": "MM",
				            "format": "MMM YYYY"
				        }, {
				            "period": "YYYY",
				            "format": "MMM YYYY"
				        }],
				        "parseDates": true,
				        "autoGridCount": true,
				        "axisColor": "#555555",
				        "gridAlpha": 0.1,
				        "gridColor": "#FFFFFF",
				        "gridCount": 50
				    },
				    "export": {
				    	"enabled": true,
				    	 "menu":[]
				     }
				};
			
			
			gaugeChart = AmCharts.makeChart("chartDivBarChart-"+$scope.id, config);
			
			$scope.$on("downloadImages",function($event, message){
				gaugeChart["export"].capture({}, function() {
				    // SAVE TO PNG
				    this.toPNG({}, function(base64) {
				    	$scope.exportdata[$scope.id]=base64;
				    	$scope.$emit("imageextractedCapital",{'type':$scope.id,'base64':base64});
				    });
				});
			});
			
						
		}
	};
	
	angular
	.module('quantixApp')
	.directive('companyDetailsBarChart',function() {
		return {
			restrict : 'E',
			replace:true,
			scope : {
				id:'@',
				plotData:'=?',
				exportdata:'='
			},
			templateUrl : 'app/company/companyProfile/companyDetailsBarChart.html',
			controller : companyDetailsBarChartController,
			link:  function(scope, element, attributes){
				
				scope.$watch('plotData', function(value){
					if(value){
						scope.initialise();
					}
				});

			}
	
		}
	});
	
})();